module.exports = __webpack_public_path__ + "img/ps-2ALT.97ad0aa8.jpg";